import { render } from "./WalletView.vue?vue&type=template&id=2baf4db4&scoped=true"
import script from "./WalletView.vue?vue&type=script&lang=js"
export * from "./WalletView.vue?vue&type=script&lang=js"

import "./WalletView.vue?vue&type=style&index=0&id=2baf4db4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baf4db4"]])

export default __exports__